import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { setUsernameSearch } from "../../../redux/searchUsers";

// interface UserNameSearchProps {
//   onInputUserName: (inputText: string) => void;
// }

const UsernameSearch = () =>
  // { onInputUserName }: UserNameSearchProps

  {
    const dispatch = useDispatch();
    const searchUsers = useSelector((state: RootState) => state.searchUsers);

    return (
      <>
        <div className="search_form_plate">
          <div className="field_block">
            <label htmlFor="field-5" className="search_label">
              לפי שם משתמש
            </label>
            <input
              className="txt_field w-input"
              maxLength={256}
              name="field-5"
              data-name="Field 5"
              placeholder="הקלד שם משתמש"
              type="text"
              id="field-5"
              onChange={(e) => {
                // onInputUserName(e.target.value);
                dispatch(setUsernameSearch(e.target.value));
              }}
              value={searchUsers.username}
            />
            <div className="form_allert">----------------------------</div>
          </div>
        </div>
      </>
    );
  };

export default UsernameSearch;
